import { ENV_NAME } from '../../../config';



export const EnvRibbonComponent : ng.IComponentOptions = {
    template: `
    <div class="env-ribbon right-bottom fixed"  ng-if="'Production' !== '${ENV_NAME}'" title="${ENV_NAME}"></div>
    `
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/env-ribbon/env-ribbon.component.ts